import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useState, ReactNode, useEffect } from 'react';

import { MAINTENANCE_CONFIG } from '../config';
import Maintenance from '../pages/Maintenance';

// Enable UTC plugin
dayjs.extend(utc);

// ----------------------------------------------------------------------

type MaintenanceGuardProps = {
  children: ReactNode;
};

function isInMaintenanceWindow(): boolean {
  const { startTime, endTime } = MAINTENANCE_CONFIG;

  // If no maintenance window configured, return false
  if (!startTime || !endTime) {
    return false;
  }

  // Parse config times as UTC
  const now = dayjs.utc();
  const start = dayjs.utc(startTime);
  const end = dayjs.utc(endTime);

  // Validate dates
  if (!start.isValid() || !end.isValid()) {
    console.warn('MaintenanceGuard: Invalid maintenance window dates');
    return false;
  }

  return now.isAfter(start) && now.isBefore(end);
}

export default function MaintenanceGuard({ children }: MaintenanceGuardProps) {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(() => isInMaintenanceWindow());

  useEffect(() => {
    // Check maintenance status periodically (every minute)
    const interval = setInterval(() => {
      setIsMaintenanceMode(isInMaintenanceWindow());
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  if (isMaintenanceMode) {
    return <Maintenance endTime={MAINTENANCE_CONFIG.endTime} />;
  }

  return <>{children}</>;
}
